import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  bookingday,
  bookingrevenue,
  cancelbooking,
  citycovered,
  completedbooking,
  completedbookingcount,
  creditoutstanding,
  currentblockedrooms,
  dayouting,
  debitoutstanding,
  futureblockedroom,
  futurebooking,
  gettogthercount,
  justwalking,
  locationcoverd,
  mmcprofit,
  mmcrevenue,
  mmcsubsproperty,
  mmcunsubsproperty,
  moneyexpired,
  moneyredeem,
  moneyutilized,
  overallprofit,
  overallrevenue,
  receivebooking,
  recommendationprofit,
  recommendationrevenue,
  recommendedproperty,
  recommendedunsubproperty,
  requestaccepted,
  requestpending,
  requestreceived,
  requestreject,
  roomsharing,
  statecoverd,
  successfulcheckin,
  successfulcheckout,
  tiprevenue,
  tipsprofit,
  tomarrowbooking,
  totalcustomer,
  totalemp,
  totalproper,
  totalrecep,
  totalrooms,
  totolproowner,
  unsuccessfulcheckin,
} from "../../assets/img";
import GroupIcon from "@mui/icons-material/Group";
import ChartPage from "../../components/ChartPage";
import { useDispatch } from "react-redux";
import { useLazyDashboardQuery } from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import { ListDashboard } from "../../redux/api/DummyJson";
import TopHeader from "./TopHeader";

const Dashboard = () => {
  const dispatch = useDispatch();
  const [list, setList] = useState({});

  // RTK QUERY
  const [dashboardApi] = useLazyDashboardQuery();

  const getDashboard = () => {
    dispatch(saveLoader(true));
    dashboardApi()
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setList(res);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (localStorage?.getItem("token")) {
      getDashboard();
    }
    // setList(ListDashboard);
  }, []);

  return (
    <div className="dashRightView home_section">
      {" "}
      <TopHeader type={"dashboard"} />
      <div className="content2">
        <h2 class="dash-baord-hh2 f2">User Base</h2>
        <Row>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Customers
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.total_customers}
                    </div>
                    <img
                      src={totalcustomer}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Col>

          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Property Owners
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.total_property_owners}
                    </div>
                    <img
                      src={totolproowner}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Col>

          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Receptionist
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.total_receptionists}
                    </div>
                    <img
                      src={totalrecep}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Col>

          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Active Employess
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.total_active_employees}
                    </div>
                    <img
                      src={totalemp}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <h2 class="dash-baord-hh2 mt-5 mb-3 f2">Properties</h2>

        <Row>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Properties
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.total_properties}
                    </div>
                    <img
                      src={totalproper}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Rooms
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.total_rooms}
                    </div>
                    <img
                      src={totalrooms}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <h2 class="dash-baord-hh2 mt-5 mb-3 f2">Bookings</h2>
        <Row>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Received Bookings
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.total_bookings}
                    </div>
                    <img
                      src={receivebooking}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Completed Bookings
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.total_completed_bookings}
                    </div>
                    <img
                      src={completedbooking}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Cancelled Bookings
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.cancelled_bookings}
                    </div>
                    <img
                      src={completedbookingcount}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <h2 class="dash-baord-hh2 mt-5 mb-3 f2">Property Request</h2>
        <Row>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Request Received
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.all_properties}
                    </div>
                    <img
                      src={requestreceived}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Request Accepted
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.accepted_properties}
                    </div>
                    <img
                      src={requestaccepted}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Request Rejected
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.rejected_properties}
                    </div>
                    <img
                      src={requestreject}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Request Pending
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.requested_properties}
                    </div>
                    <img
                      src={requestpending}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <h2 class="dash-baord-hh2 mt-5 mb-3 f2">Location Based</h2>

        <Row>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total States Covered
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.states}
                    </div>
                    <img
                      src={statecoverd}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Cities Covered
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.cities}
                    </div>
                    <img
                      src={citycovered}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Locations Covered
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.locations}
                    </div>
                    <img
                      src={locationcoverd}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <h2 class="dash-baord-hh2 mt-5 mb-3 f2">Today Received Bookings</h2>
        <Row>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Received Bookings of the day
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.today_bookings}
                    </div>
                    <img
                      src={bookingday}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Room Booking Count
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.today_room_bookings}
                    </div>
                    <img
                      src={locationcoverd}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Get Together Count
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.today_get_together}
                    </div>
                    <img
                      src={gettogthercount}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Day outing count
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.today_day_outing}
                    </div>
                    <img
                      src={dayouting}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Just Walking count
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.today_just_walking}
                    </div>
                    <img
                      src={justwalking}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Room Sharing Count
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.today_room_sharing}
                    </div>
                    <img
                      src={roomsharing}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <h2 class="dash-baord-hh2 mt-5 mb-3 f2">Todays</h2>
        <Row>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Bookings Count of the day
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.today_bookings}
                    </div>
                    <img
                      src={bookingday}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Successfull Checkins
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.today_checkins}
                    </div>
                    <img
                      src={successfulcheckin}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Successfull Checkout
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.today_checkouts}
                    </div>
                    <img
                      src={successfulcheckout}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Unsuccessfull Checkins
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.today_unsuccessfull_checkins}
                    </div>
                    <img
                      src={unsuccessfulcheckin}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <h2 class="dash-baord-hh2 mt-5 mb-3 f2">Tomorrows</h2>
        <Row>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Tomorrow Bookings Count
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.tomorrow_checkins}
                    </div>
                    <img
                      src={tomarrowbooking}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Future Bookings Count
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.future_bookings}
                    </div>
                    <img
                      src={futurebooking}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <h2 class="dash-baord-hh2 mt-5 mb-3 f2">Wallet Moneys</h2>
        <Row>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Money Redeemed
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.total_properties}
                    </div>
                    <img
                      src={moneyredeem}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Money Utilized
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.total_properties}
                    </div>
                    <img
                      src={moneyutilized}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Money Expired
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.total_properties}
                    </div>
                    <img
                      src={moneyexpired}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <h2 class="dash-baord-hh2 mt-5 mb-3 f2">Cancellation</h2>
        <Row>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Today unsuccessfully checkin Count
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.today_unsuccessfull_checkins}
                    </div>
                    <img
                      src={unsuccessfulcheckin}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Cancelled Bookings Count
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.total_canceled_bookings}
                    </div>
                    <img
                      src={cancelbooking}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <h2 class="dash-baord-hh2 mt-5 mb-3 f2">Blocked List</h2>
        <Row>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Current Date Blocked Rooms Count
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.c_blocked_rooms}
                    </div>
                    <img
                      src={currentblockedrooms}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>

          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Future Date Blocked Rooms Count
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.f_blocked_rooms}
                    </div>
                    <img
                      src={futureblockedroom}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <h2 class="dash-baord-hh2 mt-5 mb-3 f2">Recommendations and Mcc</h2>
        <Row>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Recommendation subscribed properties
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.rec_subscribed_properties}
                    </div>
                    <img
                      src={recommendedproperty}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Recommendation unsubscribed properties
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.rec_unsubscribed_properties}
                    </div>
                    <img
                      src={recommendedunsubproperty}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total MMC subscribed properties
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.subscribed_properties}
                    </div>
                    <img
                      src={mmcsubsproperty}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total MMC unsubscribed properties
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.unsubscribed_properties}
                    </div>
                    <img
                      src={mmcunsubsproperty}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <h2 class="dash-baord-hh2 mt-5 mb-3 f2">Revenue</h2>
        <Row>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Bookings Revenue
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {Number(list?.booking_transactions).toFixed(2)}
                    </div>
                    <img
                      src={bookingrevenue}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Recommendations Revenue
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.recommendation_amount}
                    </div>
                    <img
                      src={recommendationrevenue}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total MMC Revenue
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.mcc_amount}
                    </div>
                    <img
                      src={mmcrevenue}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Tips Revenue
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.tip_amount}
                    </div>
                    <img
                      src={tiprevenue}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>

          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Overall Revenue
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {Number(
                        list?.booking_transactions +
                          list?.mcc_amount +
                          list?.recommendation_amount +
                          list?.tip_amount
                      ).toFixed(2)}
                    </div>
                    <img
                      src={overallrevenue}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <h2 class="dash-baord-hh2 mt-5 mb-3 f2">Transactions</h2>
        <Row>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Debit Outstanding
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.booking_owner_payments}
                    </div>
                    <img
                      src={debitoutstanding}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>

          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Credit Outstanding
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.mcc_amount + list?.recommendation_amount}
                    </div>
                    <img
                      src={creditoutstanding}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <h2 class="dash-baord-hh2 mt-5 mb-3 f2">Earnings after Tax</h2>
        <Row>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Recommendation Profit
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.after_tax_rec}
                    </div>
                    <img
                      src={recommendationprofit}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Mcc Profit
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.after_tax_mcc}
                    </div>
                    <img
                      src={mmcprofit}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Total Tips Profit
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.after_tax_tips}
                    </div>
                    <img
                      src={tipsprofit}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={3} xl={3}>
            <div className="dash_box block-link-pop mt-3 mb-3">
              <div className="px-3 py-3 d-flex">
                <div class="flex-grow-1">
                  <div class="font-size-sm font-w600 letter_space text-uppercase text-muted staf-dash-tit mt-1 f1">
                    Overall Profit
                  </div>

                  <div className="d-flex ac-jb">
                    <div class="font-size-h3 mt-2 mb-2 text-dark mx-3">
                      {list?.after_tax_profit}
                    </div>
                    <img
                      src={overallprofit}
                      alt="Header Avatar"
                      style={{ width: "35px", marginRight: "20px" }}
                    />
                  </div>
                </div>
                <div class="d-flex ml-2 mt-4">
                  <div
                    class={`flex-grow-1 px-1 rounded-lg bg-danger-light`}
                  ></div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        {/* <Row>
          <ChartPage />
        </Row> */}
      </div>
    </div>
  );
};

export default Dashboard;
